import * as ToggleMenuFlyout from '@ori-events/toggle-menu-flyout';
import { useWindowSize } from '@ori/presentation-hooks';
import type { FC } from 'react';

import { useAppConfig } from '../../../../context/configurationContext';
import { useActiveMenu, useSearchInput } from '../../../../context/navigation';
import { useTopAreaBanner } from '../../../../context/topAreaBannerContext';
import { SearchPreview } from '../../../SearchPreview';
import { SearchPreviewSkeleton } from '../../../SearchPreviewSkeleton';
import { SearchPreviewRoot, SearchPreviewContent } from './styles';

export interface SearchPreviewContainerProps {
  query: string;
}

export const SearchPreviewContainer: FC<SearchPreviewContainerProps> = ({ query }) => {
  const { activeMenu } = useActiveMenu();
  const { height } = useWindowSize();
  const { results, isLoading } = useSearchInput();
  const isActive = activeMenu === ToggleMenuFlyout.MenuTypes.SearchResults;
  const { visible: isTopBannerVisible } = useTopAreaBanner();
  const { showSearchOnScroll } = useAppConfig();

  if (!isActive || !query) {
    return null;
  }

  return (
    <SearchPreviewRoot>
      <SearchPreviewContent
        innerHeight={height}
        isTopBannerVisible={isTopBannerVisible}
        showSearchOnScroll={showSearchOnScroll}
      >
        {isLoading ? (
          <SearchPreviewSkeleton />
        ) : (
          <SearchPreview
            query={query}
            numberOfProducts={results?.numberOfProducts ?? 0}
            products={results?.products ?? []}
            suggestions={results?.suggestions ?? []}
          />
        )}
      </SearchPreviewContent>
    </SearchPreviewRoot>
  );
};
